import { render, staticRenderFns } from "./UserModulesSuccess.vue?vue&type=template&id=1aa60352&"
import script from "./UserModulesSuccess.vue?vue&type=script&lang=js&"
export * from "./UserModulesSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports